import React from 'react'
import "./Tophead.css"
import cv from "../../Resources/Downloadable/StarmanCV.pdf"

export default function Footerbar() {
  return (
    <>
    <div class="top-bar">
        <div className="container-top lft-foot">
          <div><a href="www.linkedin.com/in/idhant-dabral" target="_blank">Linkden</a></div>
          <div><a href="mailto: starmandev@gmail.com" target="_blank">email</a></div>
          <div><a href="https://github.com/St4rman" target="_blank">github</a></div>
          <div><a href={cv} download target="_blank">resume</a></div>
          <div><a href="https://drive.google.com/drive/folders/1sIQEgc9Cu2AgQGwe--7t4i5mmiUCGQUr?usp=sharing" target="_blank">showcase</a></div>
          
        </div>
      </div>
    </>
  )
}
